import { useLanguage } from "@/hooks/useLanguage";
import { Globe } from "lucide-react";

const LanguageSelector = () => {
  const { language, languages, openLanguageModal, t } = useLanguage();

  const currentLang = languages.find((l) => l.code === language);

  return (
    <button
      onClick={openLanguageModal}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-white/80 hover:bg-white border border-gray-200 hover:border-primary/50 transition-all text-sm font-medium text-primary-950 shadow-sm"
      data-testid="language-selector"
    >
      <Globe size={16} className="text-primary" />
      <span>{currentLang?.nativeName || "English"}</span>
    </button>
  );
};

export default LanguageSelector;
